import { useEffect, useMemo, useState } from "react";
import { Tabs, Modal, Button, message, Pagination, Input } from "antd";
import { Spinner } from "@chakra-ui/react";
import ExcelJS from "exceljs";
import {
  useGetMeetingsQuery,
  usePutMeetingsMutation,
  useDeleteMeetingsMutation,
  useAddMeetingNoteMutation,
} from "../../../services/newMeeting";
import { useDrag, useDrop } from "react-dnd";
import { ThemeButton } from "../../../components/components";

const { TabPane } = Tabs;

// Define the type for draggable items
const ItemType = "RECEIVER";

const SponsorMeetings = ({ eventID, attendance }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [additonalMeetings, setAdditonalMeetings] = useState([]);
  const [oldMeeting, setOldMeeting] = useState([]);
  const [swapCounter, setSwapCounter] = useState(0);
  const [currentSlotId, setCurrentSlotId] = useState("");
  const [currentSlot, setCurrentSlot] = useState({});
  const [sponsorOrder, setSponsorOrder] = useState([]);
  const [filteringAdditonalMeetings, setFilteringAdditonalMeetings] = useState(
    []
  );

  const [clickedSponsor, setClickedSponsor] = useState(null);
  const [activeTab, setActiveTab] = useState('additional');
  const [autoFilling, setAutoFilling] = useState(false);
  const scheduledMeetings = [
    {
      name: "Jhon Doe",
      company: "Imperial Clinical Research Services",
      status: "Best Match",
      statusClass: "bg-green-100 border-l-4 border-l-green-400",
      statusTextClass: "text-green-400",
      btnClass: "bg-green-500 hover:bg-green-600",
      avatarBg: "bg-green-200"
    },
    {
      name: "Jhon Doe",
      company: "Imperial Clinical Research Services",
      status: "Booked",
      statusClass: "bg-amber-50 border-l-4 border-l-amber-400",
      statusTextClass: "text-amber-400",
      btnClass: "bg-amber-500 hover:bg-amber-600",
      avatarBg: "bg-amber-200"
    },
    {
      name: "Jhon Doe",
      company: "Imperial Clinical Research Services",
      status: "Absent",
      statusClass: "bg-red-100 border-l-4 border-l-red-400",
      statusTextClass: "text-red-400",
      btnClass: "bg-red-500 hover:bg-red-600",
      avatarBg: "bg-red-200"
    },
    {
      name: "Jhon Doe",
      company: "Imperial Clinical Research Services",
      status: "Best Match",
      statusClass: "bg-green-100 border-l-4 border-l-green-400",
      statusTextClass: "text-green-400",
      btnClass: "bg-green-500 hover:bg-green-600",
      avatarBg: "bg-green-200"
    }
  ];
  // ... rest of your code ...
  const [slotsData, setSlotsData] = useState({
    meetingType: "sponsor-to-all",
    eventId: eventID,
  });

  const {
    data,
    refetch,
    isLoading: slotFetchingLoading,
  } = useGetMeetingsQuery(slotsData);
  const [updateMeeting] = usePutMeetingsMutation();
  const [deleteMeetings] = useDeleteMeetingsMutation();
  const [addMeetingNote] = useAddMeetingNoteMutation();

  const [notesModalOpen, setNotesModalOpen] = useState(false);
  const [notesModalMeetingId, setNotesModalMeetingId] = useState(null);
  const [newNoteText, setNewNoteText] = useState("");
  const [addingNote, setAddingNote] = useState(false);
  const [selectedMeetingIdForDone, setSelectedMeetingIdForDone] = useState(null);
  const [selectedMeetingForDetails, setSelectedMeetingForDetails] = useState(null);
  const [markingDone, setMarkingDone] = useState(false);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    setSlotsData((prevData) => ({ ...prevData, page: page }));
    refetch();
  };

  useEffect(() => {
    if (data?.meetings?.length > 0) {
      const order = [
        ...new Set(
          data.meetings
            .filter(
              (m) => !m.isAdditional && m.meetingType === slotsData.meetingType
                && eventID === m.event?._id)
            .map((m) => m.sender?._id)
            .filter(Boolean) // This will remove any undefined or null values
        ),
      ];
      setSponsorOrder(order);
    }
  }, [data, slotsData.meetingType]);

  useEffect(() => {
    refetch();
  }, [slotsData.meetingType, refetch]);

  const meetings = data?.meetings;

  useEffect(() => {
  if (meetings?.length > 0) {
    const filteredMeetings = meetings
      ?.filter((item) =>
        item?.isAdditional === false &&
        item?.meetingType === slotsData?.meetingType &&
        eventID === item?.event?._id
      )
      ?.sort((a, b) => {
        const dayA = parseInt(a?.slot?.day?.split(" ")[1]);
        const dayB = parseInt(b?.slot?.day?.split(" ")[1]);

        if (dayA !== dayB) {
          return dayA - dayB;
        }

        const timeA = new Date(`1970/01/01 ${a?.slot?.startTime}`);
        const timeB = new Date(`1970/01/01 ${b?.slot?.startTime}`);

        return timeA - timeB;
      });

    console.log(filteredMeetings, "filteredMeetingsssssssssssssss");
    setFilteringAdditonalMeetings(filteredMeetings);
  }
}, [meetings, slotsData?.meetingType]);

  if (slotFetchingLoading) {
    return <Spinner />;
  }

  // if (!data?.meetings?.length > 0) {
  //   return null;
  // }

  console.log(filteringAdditonalMeetings, "filteringAdditonalMeetings");

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const openModal = (
    oldDeligatee,
    sender,
    meetingId,
    currentSLotId,
    currentSLot,
    sponsorIndex
  ) => {

    setClickedSponsor(sender);

    const filterIsAdditonalMeetings = meetings?.filter(
      (item) => item.isAdditional === true && item.sender?._id === sender?._id
    );
    const filterOldMeeting = meetingId
      ? meetings.filter((item) => item?._id === meetingId)
      : [];

    // if (filterIsAdditonalMeetings?.length === 0) {
    //   message.info("No additional meetings available for this sponsor.");
    //   return;
    // }

    setOldMeeting(filterOldMeeting);
    setSelectedMeetingIdForDone(meetingId || null);
    setCurrentSlotId(currentSLotId);
    setCurrentSlot(
      currentSLot || {
        day: filteringAdditonalMeetings?.find(
          (m) => m.slot?._id === currentSLotId
        )?.slot?.day,
      }
    );
    setAdditonalMeetings(filterIsAdditonalMeetings);

    console.log(currentSlot, "currentSlot");
    setIsModalOpen(true);
  };

  console.log(clickedSponsor, "clickedSponsor");

  const findExistingMeeting = (id, slotId, isSender, exceptMeetingId) => {
    console.log("click", "click");
    const findMeeting = filteringAdditonalMeetings?.filter((meeting) =>
      isSender
        ? meeting.sender?._id.toString() === id.toString() &&
        (exceptMeetingId
          ? meeting._id.toString() !== exceptMeetingId.toString()
          : true)
        : meeting.receiver?._id.toString() === id.toString() &&
        (exceptMeetingId
          ? meeting._id.toString() !== exceptMeetingId.toString()
          : true)
    );

    console.log(findMeeting, "findMeeting");
    return findMeeting.find(
      (item) => item.slot?._id.toString() === slotId.toString()
    );
  };

  const findExistingMeeting2 = (id, slotId, isSender, exceptMeetingIds) => {
    console.log("click", "click");
    const findMeeting = filteringAdditonalMeetings?.filter(
      (meeting) =>
        isSender
          ? meeting.sender?._id.toString() === id.toString() &&
          (!exceptMeetingIds ||
            !exceptMeetingIds.includes(meeting._id.toString())) // Updated to check against an array
          : meeting.receiver?._id.toString() === id.toString() &&
          (!exceptMeetingIds ||
            !exceptMeetingIds.includes(meeting._id.toString())) // Updated to check against an array
    );

    console.log(findMeeting, "findMeeting");
    return findMeeting.find(
      (item) => item.slot?._id.toString() === slotId.toString()
    );
  };

  const showErrorMessage = (conflictingMeeting) => {
    const conflictingReceiver =
      conflictingMeeting.receiver?.user?.first_name +
      " " +
      conflictingMeeting.receiver?.user?.last_name;

    const conflictingSender =
      conflictingMeeting.sender?.user?.first_name +
      " " +
      conflictingMeeting.sender?.user?.last_name;

    const conflictingSlot = `${conflictingMeeting?.slot?.startTime} - ${conflictingMeeting?.slot?.endTime} (${conflictingMeeting?.slot?.day})`;

    const key = `error-${Date.now()}`;

    message.error({
      content: (
        <div>
          <p>
            {conflictingReceiver} already has a meeting with {conflictingSender}{" "}
            at {conflictingSlot}.
          </p>
          <ThemeButton
            size="small"
            onClick={() => message.destroy(key)}
            style={{ marginTop: "8px" }}
            content={"Dismiss"}
          />
        </div>
      ),
      duration: 8,
      key,
    });
  };

  // for repplace from addtional meeting
  const handleReplaceDelegate = async (meeting, additionalMeetingIndex) => {
    console.log(meeting, "meetingasdas");
    console.log(oldMeeting[0], "oldMeeting[0]");
    // If oldMeeting is empty, we're dealing with an empty slot
    const isEmptySlot = oldMeeting?.length === 0;

    const mapUpdatedMeeting = {
      event: isEmptySlot ? eventID : oldMeeting[0]?.event?._id,
      isAdditional: false,
      meetingType: slotsData.meetingType,
      receiver: meeting.receiver?._id,
      sender: meeting.sender?._id,
      status: "accepted",
      slot: currentSlotId,
    };

    try {
      const checkAllowedMeetings = filteringAdditonalMeetings.filter(
        (item) => item.sender?._id === meeting.sender?._id
      );

      const CheckExistingMeetingForReceiverAsSender = findExistingMeeting(
        meeting.sender?._id,
        currentSlotId,
        true, // true indicates sender
        oldMeeting[0]?._id
      );

      const CheckExistingMeetingForReceiverAsReceiver = findExistingMeeting(
        meeting.receiver?._id,
        currentSlotId,
        false,
        oldMeeting[0]?._id
      );

      const CheckExistingMeetingForDifferentSender = findExistingMeeting(
        meeting.receiver?._id,
        currentSlotId,
        true, // true indicates sender
        oldMeeting[0]?._id
      );

      const CheckExistingMeetingForDifferentReceiver = findExistingMeeting(
        meeting.sender?._id,
        currentSlotId,
        false,
        oldMeeting[0]?._id
      );

      const conflictingMeeting =
        CheckExistingMeetingForReceiverAsSender ||
        CheckExistingMeetingForReceiverAsReceiver ||
        CheckExistingMeetingForDifferentSender ||
        CheckExistingMeetingForDifferentReceiver;

      console.log(conflictingMeeting, "conflictingMeetingfoRrEPLACE");
      if (conflictingMeeting) {
        showErrorMessage(conflictingMeeting);
        return;
      }

      console.log(checkAllowedMeetings, "checkAllowedMeetings");
      let updateMeetingResult;
      if (isEmptySlot) {
        if (checkAllowedMeetings?.length >= meeting.sender.allowed_meetings) {
          message.error(
            `This ${meeting.sender?.user?.user_type} has reached their maximum allowed meetings.`
          );
          return;
        }
        // Create a new meeting for the empty slot
        updateMeetingResult = await updateMeeting({
          id: meeting?._id,
          body: mapUpdatedMeeting,
        });

        if (updateMeetingResult.data.status === 200) {
          refetch();
          handleModalClose();
        } else {
          message.error(
            isEmptySlot ? "Failed to add meeting" : "Failed to replace meeting"
          );
        }
      } else {
        // Update existing meeting
        updateMeetingResult = await updateMeeting({
          id: oldMeeting[0]?._id,
          body: mapUpdatedMeeting,
        });
      }

      if (updateMeetingResult.data.status === 200) {
        if (!oldMeeting[0]?._id) return null;

        // Update the additional meeting to mark it as used
        const updateAdditionalMeetingResult = await updateMeeting({
          id: meeting?._id,
          body: {
            ...meeting,
            receiver: oldMeeting[0]?.receiver,
            isAdditional: true,
            status: "accepted",
          },
        });

        console.log(
          updateAdditionalMeetingResult,
          "updateAdditionalMeetingResult"
        );

        if (updateAdditionalMeetingResult.data.status === 200) {
          if (!oldMeeting[0]?._id) return null;

          message.success(
            isEmptySlot
              ? "Meeting Added Successfully"
              : "Meeting Replaced Successfully"
          );
          refetch();
          handleModalClose();
        }
      } else {
        message.error(
          isEmptySlot ? "Failed to add meeting" : "Failed to replace meeting"
        );
      }
    } catch (error) {
      console.error("Error in handleReplaceDelegate:", error);
      message.error("An error occurred while updating the meeting");
    }
  };

  // Extract values for rendering
  const handleTabChange = (key) => {
    setSlotsData((prevData) => ({
      ...prevData,
      meetingType: key,
    }));

    setFilteringAdditonalMeetings([]);
  };

  const handleAutoFillEmptySlots = async () => {
    setAutoFilling(true);
    try {
      const slotMap = {};
      filteringAdditonalMeetings.forEach((m) => {
        if (m.slot?._id) slotMap[m.slot._id] = m.slot;
      });
      const allSlotIds = Object.keys(slotMap);

      const slotOccupancy = {};
      allSlotIds.forEach((id) => { slotOccupancy[id] = new Set(); });
      filteringAdditonalMeetings.forEach((m) => {
        const sid = m.slot?._id;
        if (sid && slotOccupancy[sid]) {
          if (m.sender?._id) slotOccupancy[sid].add(m.sender._id);
          if (m.receiver?._id) slotOccupancy[sid].add(m.receiver._id);
        }
      });

      const sponsorMap = {};
      filteringAdditonalMeetings.forEach((m) => {
        const sid = m.sender?._id;
        if (!sid) return;
        if (!sponsorMap[sid]) {
          sponsorMap[sid] = { sender: m.sender, occupiedSlots: new Set(), count: 0 };
        }
        sponsorMap[sid].occupiedSlots.add(m.slot?._id);
        sponsorMap[sid].count++;
      });

      const allAdditional = (meetings || []).filter((m) => m.isAdditional === true);
      const fillOps = [];
      const usedAdditionalIds = new Set();

      for (const [sponsorId, info] of Object.entries(sponsorMap)) {
        const allowed = info.sender?.allowed_meetings || 0;
        let currentCount = info.count;
        if (currentCount >= allowed) continue;

        const emptySlotIds = allSlotIds.filter((id) => !info.occupiedSlots.has(id));
        if (emptySlotIds.length === 0) continue;

        const additionalForSponsor = allAdditional.filter(
          (m) => m.sender?._id === sponsorId
        );
        if (additionalForSponsor.length === 0) continue;

        for (const slotId of emptySlotIds) {
          if (currentCount >= allowed) break;
          const slot = slotMap[slotId];

          const bestMatch = additionalForSponsor.find((am) => {
            if (usedAdditionalIds.has(am._id)) return false;
            const receiverId = am.receiver?._id;
            if (!receiverId) return false;
            if (am.receiver?.attendance && !am.receiver.attendance.includes(slot?.day)) return false;
            if (slotOccupancy[slotId]?.has(receiverId)) return false;
            return true;
          });

          if (!bestMatch) continue;

          fillOps.push({
            additionalMeetingId: bestMatch._id,
            slotId,
            senderId: bestMatch.sender?._id,
            receiverId: bestMatch.receiver?._id,
          });

          usedAdditionalIds.add(bestMatch._id);
          currentCount++;
          info.occupiedSlots.add(slotId);
          if (slotOccupancy[slotId]) {
            slotOccupancy[slotId].add(bestMatch.sender?._id);
            slotOccupancy[slotId].add(bestMatch.receiver?._id);
          }
        }
      }

      if (fillOps.length === 0) {
        message.info("No empty slots could be auto-filled with best matches.");
        return;
      }

      let filledCount = 0;
      let errorCount = 0;

      for (const op of fillOps) {
        try {
          const result = await updateMeeting({
            id: op.additionalMeetingId,
            body: {
              event: eventID,
              isAdditional: false,
              meetingType: slotsData.meetingType,
              receiver: op.receiverId,
              sender: op.senderId,
              status: "accepted",
              slot: op.slotId,
            },
          });
          if (result?.data?.status === 200) {
            filledCount++;
          } else {
            errorCount++;
          }
        } catch (err) {
          console.error("Auto-fill error:", err);
          errorCount++;
        }
      }

      if (filledCount > 0) {
        message.success(`Auto-filled ${filledCount} meeting slot(s).`);
        refetch();
      }
      if (errorCount > 0) {
        message.warning(`${errorCount} slot(s) could not be filled.`);
      }
    } finally {
      setAutoFilling(false);
    }
  };

  // Swap meetings if dropping on an occupied slot
  const handleSwapMeetings = async (draggedId, droppedOnMeetingId) => {
    if (draggedId && droppedOnMeetingId && draggedId !== droppedOnMeetingId) {
      console.log(
        `Swapping Meeting ${draggedId} with Meeting ${droppedOnMeetingId}`
      );

      const draggedMeeting = filteringAdditonalMeetings.find(
        (item) => item?._id === draggedId
      );
      const droppedMeeting = filteringAdditonalMeetings.find(
        (item) => item?._id === droppedOnMeetingId
      );

      if (!draggedMeeting || !droppedMeeting) {
        message.error("One or both meetings not found");
        return;
      }

      // Check if swapping is within the same sender
      if (draggedMeeting.sender?._id !== droppedMeeting.sender?._id) {
        message.error(
          "Swapping is only allowed between meetings of the same sponsor"
        );
        return;
      }

      const CheckExistingMeetingForReceiverAsSender = findExistingMeeting2(
        draggedMeeting.sender?._id,
        draggedMeeting.slot?._id,
        true, // true indicates sender
        [draggedMeeting._id, droppedMeeting._id]
      );

      const CheckExistingMeetingForReceiverAsReceiver = findExistingMeeting2(
        draggedMeeting.receiver?._id,
        draggedMeeting.slot?._id,
        false,
        [draggedMeeting._id, droppedMeeting._id]
      );

      const CheckExistingMeetingForDifferentSender = findExistingMeeting2(
        draggedMeeting.receiver?._id,
        draggedMeeting.slot?._id,
        true, // true indicates sender
        [draggedMeeting._id, droppedMeeting._id]
      );

      const CheckExistingMeetingForDifferentReceiver = findExistingMeeting2(
        draggedMeeting.sender?._id,
        draggedMeeting.slot?._id,
        false,
        [draggedMeeting._id, droppedMeeting._id]
      );

      const conflictingMeetingInitial =
        CheckExistingMeetingForReceiverAsSender ||
        CheckExistingMeetingForReceiverAsReceiver ||
        CheckExistingMeetingForDifferentSender ||
        CheckExistingMeetingForDifferentReceiver;

      if (conflictingMeetingInitial) {
        showErrorMessage(conflictingMeetingInitial);
        return;
      }

      const conflictingMeeting = filteringAdditonalMeetings.find((meeting) => {
        return (
          // Check if the receiver of draggedMeeting already has another meeting at the same slot
          (meeting.slot?._id === draggedMeeting.slot?._id &&
            meeting.receiver?._id === droppedMeeting.receiver?._id &&
            meeting.sender?._id !== draggedMeeting.sender?._id) ||
          // Check if the receiver of droppedMeeting already has another meeting at the same slot
          (meeting.slot?._id === droppedMeeting.slot?._id &&
            meeting.receiver?._id === draggedMeeting.receiver?._id &&
            meeting.sender?._id !== droppedMeeting.sender?._id)
        );
      });

      if (conflictingMeeting) {
        showErrorMessage(conflictingMeeting);
        return;
      }

      const getMeetingsByDroppedSlot = filteringAdditonalMeetings.filter(
        (item) => item.slot?._id === droppedMeeting.slot?._id
      );

      console.log(getMeetingsByDroppedSlot, "getMeetingsByDroppedSlot");

      const existingMeetingInSlot = getMeetingsByDroppedSlot.find(
        (item) => item.sender?._id === draggedMeeting.receiver?._id && item.slot
      );

      console.log(existingMeetingInSlot, "existingMeetingInSlot");

      if (existingMeetingInSlot) {
        showErrorMessage(existingMeetingInSlot);
        return;
      }

      try {
        const [updateResultDragged, updateResultDropped] = await Promise.all([
          updateMeeting({
            id: draggedId,
            body: {
              ...draggedMeeting,
              receiver: droppedMeeting.receiver,
            },
          }),
          updateMeeting({
            id: droppedOnMeetingId,
            body: {
              ...droppedMeeting,
              receiver: draggedMeeting.receiver,
            },
          }),
        ]);

        if (
          updateResultDragged.data.status === 200 &&
          updateResultDropped.data.status === 200
        ) {
          message.success("Meetings swapped successfully");
          setSwapCounter((prev) => prev + 1);

          // Update the local state to reflect the changes without re-ordering
          setFilteringAdditonalMeetings((prevMeetings) =>
            prevMeetings.map((meeting) => {
              if (meeting?._id === draggedId) {
                return { ...meeting, receiver: droppedMeeting.receiver };
              }
              if (meeting?._id === droppedOnMeetingId) {
                return { ...meeting, receiver: draggedMeeting.receiver };
              }
              return meeting;
            })
          );
        } else {
          message.error("Failed to swap meetings");
        }
      } catch (error) {
        console.error("Error swapping meetings:", error);
        message.error("Error swapping meetings");
      }
    }
  };

  // Move meeting to empty slot
  const handleMoveMeeting = async (draggedId, newSlotIndex, senderId) => {
    const draggedMeeting = filteringAdditonalMeetings.find(
      (item) => item?._id === draggedId
    );

    if (!draggedMeeting) {
      message.error("Meeting not found");
      return;
    }

    // Find the new slot based on the index
    const newSlot = Object.values(
      filteringAdditonalMeetings.reduce((acc, meeting) => {
        acc[meeting.slot?._id] = meeting.slot?._id;
        return acc;
      }, {})
    )[newSlotIndex];

    const filterMatchingSlot = filteringAdditonalMeetings.find(
      (item) => item.slot?._id === newSlot
    );
    console.log(filterMatchingSlot, "newSlot");

    if (!newSlot) {
      message.error("Invalid slot");
      return;
    }

    const CheckExistingMeetingForReceiverAsSender = findExistingMeeting(
      draggedMeeting.sender?._id,
      newSlot,
      true // true indicates sender
    );

    const CheckExistingMeetingForReceiverAsReceiver = findExistingMeeting(
      draggedMeeting.receiver?._id,
      newSlot,
      false // false indicates receiver
    );

    const CheckExistingMeetingForDifferentSender = findExistingMeeting(
      draggedMeeting.receiver?._id,
      newSlot,
      true // true indicates sender
    );

    const CheckExistingMeetingForDifferentReceiver = findExistingMeeting(
      draggedMeeting.sender?._id,
      newSlot,
      false // false indicates receiver
    );

    const conflictingMeeting =
      CheckExistingMeetingForReceiverAsSender ||
      CheckExistingMeetingForReceiverAsReceiver ||
      CheckExistingMeetingForDifferentSender ||
      CheckExistingMeetingForDifferentReceiver;

    if (conflictingMeeting) {
      showErrorMessage(conflictingMeeting);
      return;
    }

    const updatedMeeting = {
      ...draggedMeeting,
      slot: newSlot,
    };

    try {
      const updateResult = await updateMeeting({
        id: draggedId,
        body: updatedMeeting,
      });
      if (updateResult.data.status === 200) {
        message.success("Meeting moved successfully");
        setSwapCounter((prev) => prev + 1); // Increment the swap counter
        refetch();
      } else {
        message.error("Failed to move meeting");
      }
    } catch (error) {
      console.error("Error moving meeting:", error);
      message.error("Error moving meeting");
    }
  };

  const ComponentTable = () => {
    // Track the ID of the meeting being dragged
    const [draggedMeetingId, setDraggedMeetingId] = useState(null);
    const [draggedOverId, setDraggedOverId] = useState(null);
    const [indexForColor, setIndexForColor] = useState(null);

    // Function to handle drag start
    const handleDragStart = (event, meetingId, index) => {
      setDraggedMeetingId(meetingId);
      event.dataTransfer.setData("text/plain", meetingId); // Store the meeting ID in the dataTransfer object
      setIndexForColor(true);
    };

    // Function to handle drop event
    const handleDrop = (event, droppedOnMeetingId, slotIndex, senderId) => {
      event.preventDefault();
      const draggedId = event.dataTransfer.getData("text/plain");

      console.log("slotIndex:", slotIndex);
      console.log("Dragged Meeting ID:", draggedId);
      console.log("Dropped On Meeting ID:", droppedOnMeetingId);
      console.log("Sender ID:", senderId);

      if (droppedOnMeetingId) {
        // Swap meetings if dropping on an occupied slot
        handleSwapMeetings(draggedId, droppedOnMeetingId);
      } else {
        // Move meeting to empty slot
        handleMoveMeeting(draggedId, slotIndex, senderId);
      }
    };

    // Function to allow dropping (necessary to prevent default behavior)
    const allowDrop = (event, meetingId) => {
      event.preventDefault();
      setDraggedOverId(meetingId);
    };


    const groupedMeetings = useMemo(() => {
      let counter = 0; // Move counter inside useMemo to reset it on each computation

      const grouped = filteringAdditonalMeetings
        .filter((meeting) => meeting?.sender && meeting?.receiver) // Filter out meetings with undefined sender or receiver
        .reduce((acc, meeting) => {
          const senderId = meeting.sender._id;
          if (!acc[senderId]) {
            // Increment counter for each new sender we encounter
            counter++;
            acc[senderId] = {
              tableNo:
                meeting.sender?.user?.user_type !== "sponsor"
                  ? "null"
                  : (() => {
                      const details =
                        meeting.sender?.user?.metadata?.atendee_details || {};
                      const type = details?.table_number_type;
                      const exhibitionName =
                        details?.exhibiton_table_number ||
                        details?.exhibition_table_number;
                      const meetingTable = details?.table_number;
                      return type === "exhibition"
                        ? exhibitionName
                        : type === "meeting"
                        ? meetingTable
                        : meetingTable || exhibitionName;
                    })(),
              sender: meeting.sender,
              slots: {},
            };
          }
          acc[senderId].slots[meeting?.slot?._id] = {
            receiver: meeting.receiver,
            startTime: meeting?.slot?.startTime,
            endTime: meeting?.slot?.endTime,
            day: meeting?.slot?.day,
            meetingId: meeting._id,
          };
          return acc;
        }, {});

      // Use sponsorOrder to maintain the original order
      return sponsorOrder.map((senderId) => grouped[senderId]).filter(Boolean);
    }, [filteringAdditonalMeetings, sponsorOrder]);

    let sponsors = groupedMeetings;

    sponsors = sponsors.map((sponsor) => ({
      ...sponsor,
      lengthSponsorMeetings: Object.keys(sponsor.slots).length,
      allowedSponsorMeetings: sponsor.sender.allowed_meetings,
    }));
    console.log(sponsors, "sponsorssssssss");

    const slotIdToLabel = filteringAdditonalMeetings.reduce((acc, meeting) => {
      if (meeting.slot?._id) {
        acc[meeting.slot._id] = `${meeting.slot.startTime || ""} - ${meeting.slot.endTime || ""} (${meeting.slot.day || ""})`;
      }
      return acc;
    }, {});
    const slotIds = Object.keys(slotIdToLabel);
    const slotLabels = Object.values(slotIdToLabel);

    const slotDayMap = useMemo(() => {
      const map = {};
      filteringAdditonalMeetings.forEach((m) => {
        if (m.slot?._id) map[m.slot._id] = m.slot;
      });
      return map;
    }, [filteringAdditonalMeetings]);

    const suggestions = useMemo(() => {
      const result = {};
      const allAdditional = meetings?.filter((m) => m.isAdditional === true) || [];

      sponsors.forEach((sponsorData) => {
        const senderId = sponsorData.sender?._id;
        if (!senderId) return;
        if (sponsorData.lengthSponsorMeetings >= sponsorData.allowedSponsorMeetings) return;

        const additionalForSponsor = allAdditional.filter(
          (m) => m.sender?._id === senderId
        );
        const usedReceiverIds = new Set();

        slotIds.forEach((slotId) => {
          if (sponsorData.slots[slotId]) return;

          const slotDay = slotDayMap[slotId]?.day;
          const suggestion = additionalForSponsor.find((am) => {
            const rid = am.receiver?._id;
            if (!rid || usedReceiverIds.has(rid)) return false;
            if (am.receiver?.attendance && !am.receiver.attendance.includes(slotDay)) return false;
            if (
              filteringAdditonalMeetings.some(
                (m) =>
                  m.slot?._id === slotId &&
                  (m.receiver?._id === rid || m.sender?._id === rid)
              )
            )
              return false;
            return true;
          });

          if (suggestion) {
            result[`${senderId}_${slotId}`] = suggestion;
            usedReceiverIds.add(suggestion.receiver?._id);
          }
        });
      });

      return result;
    }, [sponsors, slotIds, slotDayMap, filteringAdditonalMeetings, meetings]);

    const handleExportExcel = async () => {
      try {
        const thirdColLabel = slotsData.meetingType?.includes("delegate-to-all")
          ? "Delegates"
          : "Sponsors";
        const headers = [
          "Total Meetings",
          "Table No",
          thirdColLabel,
          ...slotLabels,
        ];

        const sortedSponsors = [...sponsors].sort((a, b) => a.tableNo - b.tableNo);
        const rows = sortedSponsors.map((sponsorData) => {
          const meetingCount = `${sponsorData.lengthSponsorMeetings ?? 0} / ${sponsorData.allowedSponsorMeetings ?? 0}`;
          const tableNo = String(sponsorData.tableNo ?? "");
          const name = [sponsorData.sender?.user?.first_name, sponsorData.sender?.user?.last_name].filter(Boolean).join(" ") || "";
          const company = sponsorData.sender?.user?.metadata?.delegate_details?.company
            || sponsorData.sender?.user?.metadata?.atendee_details?.company
            || "";
          const slotCells = slotIds.map((slotId) => {
            const meeting = filteringAdditonalMeetings.find(
              (m) => m.slot?._id === slotId && m.sender?._id === sponsorData?.sender?._id
            );
            if (!meeting?.receiver?.user) return "Empty";
            const r = meeting.receiver;
            const n = [r?.user?.first_name, r?.user?.last_name].filter(Boolean).join(" ") || "";
            const c = r?.user?.metadata?.delegate_details?.company || r?.user?.metadata?.atendee_details?.company || "";
            const status = meeting?.status || "";
            return status ? `${n} (${c}) - ${status}` : `${n} (${c})`;
          });
          const thirdCol = company ? name + " (" + company + ")" : name;
          return [meetingCount, tableNo, thirdCol, ...slotCells];
        });

        const workbook = new ExcelJS.Workbook();
        const sheet = workbook.addWorksheet("Meetings", { views: [{ state: "frozen", ySplit: 1 }] });
        const headerRow = sheet.addRow(headers);
        headerRow.font = { bold: true };
        headerRow.eachCell((cell) => { cell.font = { bold: true }; });
        rows.forEach((row) => sheet.addRow(row));

        const buf = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buf], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `meetings-${slotsData.meetingType || "export"}-${new Date().toISOString().slice(0, 10)}.xlsx`;
        a.click();
        URL.revokeObjectURL(url);
        message.success("Export downloaded.");
      } catch (err) {
        console.error(err);
        message.error("Export failed.");
      }
    };

    return (
      <div className="relative w-[1300px] ">
        <div className="mb-2 flex justify-end gap-2">
          <Button
            type="primary"
            onClick={handleAutoFillEmptySlots}
            loading={autoFilling}
            className="bg-green-600 hover:bg-green-700"
          >
            Auto Fill Best Matches
          </Button>
          <Button type="primary" onClick={handleExportExcel} className="bg-primary">
            Export to Excel
          </Button>
        </div>
        <div className="overflow-x-auto overflow-y-auto h-[70vh]">
          <table className="bg-white w-full">
            <thead className="sticky top-0 z-30">
              <tr className="flex bg-primary">
                <th className="sticky left-0 z-40 bg-primary p-4 w-[100px] flex items-center justify-center">
                  <span className="text-white capitalize">Total Meetings</span>
                </th>
                <th className="sticky left-[100px] z-40 bg-primary p-4 w-[181px] flex items-center justify-center">
                  <span className="text-white capitalize">
                    Table No
                  </span>
                </th>
                <th className="sticky left-[281px] z-40 bg-primary p-4 w-[200px] flex items-center">
                  <span className="text-white capitalize">
                    {slotsData.meetingType.includes("delegate-to-all")
                      ? "Delegates"
                      : "Sponsors"}
                  </span>
                </th>
                {Object.values(
                  filteringAdditonalMeetings.reduce((acc, meeting) => {
                    acc[
                      meeting.slot?._id
                    ] = `${meeting?.slot?.startTime} - ${meeting?.slot?.endTime} (${meeting?.slot?.day})`;
                    return acc;
                  }, {})
                ).map((slotTime, index) => (
                  <th key={index} className="p-4 max-w-[200px] flex items-center justify-center">
                    <span className="text-white ">{slotTime}</span>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {[...sponsors].sort((a, b) => a.tableNo - b.tableNo).map((sponsorData, sponsorIndex) => (
                <tr key={sponsorIndex} className="flex border-b border-gray-100 hover:bg-gray-50 h-[80px]">
                  <td className="sticky left-0 z-20 bg-white p-4 w-[100px] flex items-center justify-center">
                    <span className="text-sm">
                      {sponsorData?.lengthSponsorMeetings} / {sponsorData?.allowedSponsorMeetings}
                    </span>
                  </td>
                  <td className="sticky left-[100px] z-20 bg-white p-4 w-[181px] flex items-center justify-center">
                    <span className="text-sm">{sponsorData?.tableNo}</span>
                  </td>
                  <td className="sticky left-[281px] z-20 bg-white p-4 w-[200px] flex items-center">
                    <div className="flex items-center">
                      <div className="w-[50px] h-[50px] rounded-full overflow-hidden border-2 border-primary flex items-center justify-center bg-white">
                        {sponsorData?.sender?.user?.picture ? (
                          <img
                            src={sponsorData?.sender?.user?.picture}
                            alt={sponsorData?.sender?.user?.first_name}
                            className="w-full h-full object-cover"
                          />
                        ) : (
                          <div className="w-full h-full flex items-center justify-center bg-gray-100">
                            <span className="text-primary text-lg font-bold">
                              {sponsorData?.sender?.user?.first_name?.charAt(0)}
                            </span>
                          </div>
                        )}
                      </div>
                      <div className="pl-3">
                        <p
                          className="font-semibold text-primary text-sm truncate max-w-[120px]"
                          title={`${sponsorData?.sender?.user?.first_name} ${sponsorData?.sender?.user?.last_name}`}
                        >
                          {sponsorData?.sender?.user?.first_name}{" "}
                          {sponsorData?.sender?.user?.last_name}
                        </p>
                        <p
                          className="text-gray-600 text-xs truncate max-w-[120px]"
                          title={
                            sponsorData?.sender?.user?.metadata?.delegate_details?.company ||
                            "N/A"
                          }
                        >
                          {sponsorData?.sender?.user?.metadata?.delegate_details?.company ||
                            "N/A"}
                        </p>
                      </div>
                    </div>
                  </td>
                  {Object.values(
                    filteringAdditonalMeetings.reduce((acc, meeting) => {
                      acc[meeting.slot?._id] = meeting.slot?._id;
                      return acc;
                    }, {})
                  ).map((slotId, slotIndex) => {
                    const meeting = filteringAdditonalMeetings.find(
                      (m) =>
                        m.slot?._id === slotId &&
                        m.sender?._id === sponsorData?.sender?._id
                    );

                    console.log(meeting, "meeting");

                    const isAbsent = meeting?.receiver?.attendance
                      ? !meeting.receiver.attendance.includes(meeting?.slot?.day)
                      : false;

                    const status = meeting?.status || "pending";
                    let statusTextClass = "text-primary";
                    let statusBorderClass = "border-primary";
                    let statusAvatarBgClass = "bg-primary/10";
                    let statusCellBgClass = "";

                    if (isAbsent) {
                      statusTextClass = "text-yellow-600";
                      statusBorderClass = "border-yellow-500";
                      statusAvatarBgClass = "bg-yellow-100";
                      statusCellBgClass = "bg-yellow-50";
                    } else if (status === "completed") {
                      statusTextClass = "text-blue-600";
                      statusBorderClass = "border-blue-500";
                      statusAvatarBgClass = "bg-blue-100";
                      statusCellBgClass = "bg-blue-50";
                    } else if (status === "accepted") {
                      statusTextClass = "text-green-600";
                      statusBorderClass = "border-green-500";
                      statusAvatarBgClass = "bg-green-100";
                    } else if (status === "rejected") {
                      statusTextClass = "text-red-600";
                      statusBorderClass = "border-red-500";
                      statusAvatarBgClass = "bg-red-100";
                    }

                    return (
                      <td
                        key={slotIndex}
                        onDragOver={(event) =>
                          allowDrop(event, sponsorData?.slots[slotId]?.meetingId)
                        }
                        onDragLeave={() => setDraggedOverId(null)}
                        onDrop={(event) => {
                          handleDrop(
                            event,
                            sponsorData?.slots[slotId]?.meetingId,
                            slotIndex,
                            sponsorData?.sender?._id
                          );
                          setDraggedOverId(null);
                        }}
                        draggable={!!sponsorData?.slots[slotId]}
                        onDragStart={(event) =>
                          handleDragStart(
                            event,
                            sponsorData?.slots[slotId]?.meetingId
                          )
                        }
                        className={`p-4 w-[200px] flex items-center ${
                          meeting ? statusCellBgClass : "bg-gray-50"
                        } cursor-pointer hover:bg-gray-100`}
                        onClick={() => {
                          const clickedMeetingId = sponsorData?.slots[slotId]?.meetingId || null;
                          const clickedMeeting = clickedMeetingId
                            ? meetings?.find((m) => m._id === clickedMeetingId)
                            : null;
                          setSelectedMeetingForDetails(clickedMeeting || null);
                          openModal(
                            sponsorData?.slots[slotId]?.receiver || null,
                            sponsorData?.sender,
                            clickedMeetingId,
                            slotId,
                            sponsorData?.slots[slotId] || null,
                            sponsorIndex
                          );
                        }}
                        >
                          {meeting?.receiver?.user?.first_name ? (
                            <div className="flex items-center gap-3">
                              <div
                                className={`w-[50px] h-[50px] rounded-full overflow-hidden border-2 flex items-center justify-center ${statusBorderClass}`}
                              >
                                {meeting?.receiver?.user?.picture ? (
                                  <img
                                    src={meeting?.receiver?.user?.picture}
                                    alt={meeting?.receiver?.user?.first_name}
                                    className="w-full h-full object-cover"
                                  />
                                ) : (
                                  <div
                                    className={`w-full h-full flex items-center justify-center ${statusAvatarBgClass}`}
                                  >
                                    <span className="text-primary text-lg font-bold">
                                      {meeting?.receiver?.user?.first_name?.charAt(0)}
                                    </span>
                                  </div>
                                )}
                              </div>
                              <div>
                                <p
                                  className={`font-semibold text-sm truncate max-w-[120px] ${statusTextClass}`}
                                  title={`${meeting?.receiver?.user?.first_name} ${meeting?.receiver?.user?.last_name}`}
                                >
                                  {meeting?.receiver?.user?.first_name}{" "}
                                  {meeting?.receiver?.user?.last_name}
                                </p>
                                <p
                                  className="text-gray-600 text-xs truncate max-w-[120px]"
                                  title={
                                    meeting?.receiver?.user?.metadata?.delegate_details?.company ||
                                    "N/A"
                                  }
                                >
                                  {meeting?.receiver?.user?.metadata?.delegate_details?.company ||
                                    "N/A"}
                                </p>
                              </div>
                            </div>
                          ) : (() => {
                            const suggestion = suggestions[`${sponsorData?.sender?._id}_${slotId}`];
                            if (suggestion) {
                              return (
                                <div className="flex items-center gap-2">
                                  <div className="w-[36px] h-[36px] rounded-full border border-dashed border-green-400 bg-green-50 flex items-center justify-center overflow-hidden">
                                    {suggestion.receiver?.user?.picture ? (
                                      <img src={suggestion.receiver.user.picture} alt="" className="w-full h-full object-cover opacity-60" />
                                    ) : (
                                      <span className="text-green-600 text-sm font-bold">
                                        {suggestion.receiver?.user?.first_name?.charAt(0)}
                                      </span>
                                    )}
                                  </div>
                                  <div>
                                    <p
                                      className="text-green-600 font-semibold text-xs truncate max-w-[100px]"
                                      title={`${suggestion.receiver?.user?.first_name} ${suggestion.receiver?.user?.last_name}`}
                                    >
                                      {suggestion.receiver?.user?.first_name} {suggestion.receiver?.user?.last_name}
                                    </p>
                                    <p className="text-green-400 text-[10px]">Best Match</p>
                                  </div>
                                </div>
                              );
                            }
                            return (
                              <div className="h-[50px] w-full flex items-center justify-center text-gray-400">
                                Empty
                              </div>
                            );
                          })()}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  console.log(additonalMeetings, "additonalMeetings");

  const tabItems = [
    {
      key: "sponsor-to-all",
      label: "Sponsor To Delegate",
      children: <ComponentTable />,
    },
    {
      key: "delegate-to-all",
      label: "Delegate To Delegate",
      children: <ComponentTable />,
    },
  ];


  const findAllMeetingsSponsor = meetings.filter(
    (item) =>
      item?.sender?._id === clickedSponsor?._id &&
      item?.status === "accepted" &&
      item?.isAdditional !== true
  );

  const findAllMeetingsSponsorPending = meetings.filter(
    (item) =>
      item?.status === "pending" &&
      item?.sender?._id === clickedSponsor?._id &&
      item?.isAdditional !== true
  );
  console.log(findAllMeetingsSponsorPending, "findAllMeetingsSponsorPending");

  const findAllMeetingsSponsorRejected = meetings.filter(
    (item) =>
      item?.status === "rejected" &&
      item?.sender?._id === clickedSponsor?._id &&
      item?.isAdditional !== true
  );
  console.log(findAllMeetingsSponsorRejected, "findAllMeetingsSponsorRejected");

  const findAllMeetingsSponsorCompleted = meetings.filter(
    (item) =>
      item?.status === "completed" &&
      item?.sender?._id === clickedSponsor?._id &&
      item?.isAdditional !== true
  );

  return (
    <>
      <div className="">
        <Tabs items={tabItems} onChange={handleTabChange} />
      </div>

      <Modal
        open={isModalOpen}
        onCancel={handleModalClose}
        footer={false}
        width={800}
        className="rounded-xl"
      >
        <div className="flex flex-col h-[80vh]"> {/* Fixed height container */}
          {/* Header Section - Fixed */}
          <div className="flex-none p-4 border-b">
            <div className="flex items-center gap-4 overflow-x-auto scrollbar-hide">
              <Button
                className={`flex-none font-medium rounded-full px-8 py-2 min-w-[180px] ${activeTab === 'additional'
                  ? 'bg-amber-400 hover:bg-amber-500 text-white'
                  : 'text-amber-400 border-amber-400 hover:border-amber-500 hover:text-amber-500'
                  }`}
                type={activeTab === 'additional' ? "primary" : "default"}
                onClick={() => setActiveTab('additional')}
              >
                Additional Meetings
              </Button>
              <Button
                className={`flex-none font-medium rounded-full px-8 py-2 min-w-[180px] ${activeTab === 'scheduled'
                  ? 'bg-amber-400 hover:bg-amber-500 text-white'
                  : 'text-amber-400 border-amber-400 hover:border-amber-500 hover:text-amber-500'
                  }`}
                type={activeTab === 'scheduled' ? "primary" : "default"}
                onClick={() => setActiveTab('scheduled')}
              >
                Scheduled Meetings
              </Button>
              <Button
                className={`flex-none font-medium rounded-full px-8 py-2 min-w-[180px] ${activeTab === 'pending'
                  ? 'bg-amber-400 hover:bg-amber-500 text-white'
                  : 'text-amber-400 border-amber-400 hover:border-amber-500 hover:text-amber-500'
                  }`}
                type={activeTab === 'pending' ? "primary" : "default"}
                onClick={() => setActiveTab('pending')}
              >
                Pending Meetings
              </Button>
              <Button
                className={`flex-none font-medium rounded-full px-8 py-2 min-w-[180px] ${activeTab === 'rejected'
                  ? 'bg-amber-400 hover:bg-amber-500 text-white'
                  : 'text-amber-400 border-amber-400 hover:border-amber-500 hover:text-amber-500'
                  }`}
                type={activeTab === 'rejected' ? "primary" : "default"}
                onClick={() => setActiveTab('rejected')}
              >
                Rejected Meetings
              </Button>
              <Button
                className={`flex-none font-medium rounded-full px-8 py-2 min-w-[180px] ${
                  activeTab === 'completed'
                    ? 'bg-blue-500 hover:bg-blue-600 text-white'
                    : 'text-blue-500 border-blue-500 hover:border-blue-600 hover:text-blue-600'
                }`}
                type={activeTab === 'completed' ? "primary" : "default"}
                onClick={() => setActiveTab('completed')}
              >
                Completed Meetings
              </Button>
            </div>
          </div>

          {/* Content Section - Scrollable */}
          <div className="flex-1 overflow-y-auto p-4">
            {activeTab === 'additional' && (

              <>
                {additonalMeetings?.length === 0 && (
                  <div className="flex items-center justify-center h-full">
                    <p className="text-gray-500">No additional meetings found</p>
                  </div>
                )}
                <div className="flex flex-col gap-4">
                  {additonalMeetings?.map((meeting, index) => {
                    const isAbsent = !meeting?.receiver?.attendance?.includes(currentSlot?.day);
                    const findAllMeetings = filteringAdditonalMeetings.filter(
                      (item) => item?.receiver?._id === meeting?.receiver?._id
                    );
                    const isBooked = findAllMeetings.some(
                      (item) => item?.slot?._id === currentSlotId
                    );

                    const statusClass = isAbsent
                      ? "bg-red-100 border-l-4 border-l-red-400"
                      : isBooked
                        ? "bg-amber-50 border-l-4 border-l-amber-400"
                        : "bg-green-100 border-l-4 border-l-green-400";

                    const statusLabel = isAbsent
                      ? "Absent"
                      : isBooked
                        ? "Booked"
                        : "Best Match";

                    const statusBtnClass = isAbsent
                      ? "bg-red-500 hover:bg-red-600"
                      : isBooked
                        ? "bg-amber-500 hover:bg-amber-600"
                        : "bg-green-500 hover:bg-green-600";

                    const statusTextClass = isAbsent
                      ? "text-red-400"
                      : isBooked
                        ? "text-amber-400"
                        : "text-green-400";


                    return (
                      <div
                        key={index}
                        className={`${statusClass} rounded-lg p-4 flex items-center justify-between cursor-pointer hover:shadow-md transition-shadow duration-200`}
                        onClick={() =>
                          !isAbsent &&
                          !isBooked &&
                          handleReplaceDelegate(meeting, index)
                        }
                      >
                        <div className="flex items-center gap-4">
                          <div className="w-12 h-12 rounded-full overflow-hidden border-2 border-gray-200">
                            {meeting.receiver?.user?.avatar ? (
                              <img
                                src={meeting.receiver?.user?.avatar}
                                alt={meeting.receiver?.user?.first_name}
                                className="w-full h-full object-cover"
                              />
                            ) : (
                              <div className={`w-full h-full flex items-center justify-center ${isAbsent ? "bg-red-200" : isBooked ? "bg-amber-200" : "bg-green-200"}`}>
                                <span className="text-white text-lg font-bold">
                                  {meeting.receiver?.user?.first_name?.charAt(0)}
                                </span>
                              </div>
                            )}
                          </div>
                          <div>
                            <p className={`font-bold ${statusTextClass}`}>{statusLabel}</p>
                            <p className="font-semibold text-gray-700">
                              {meeting.receiver?.user?.first_name + " " + meeting.receiver?.user?.last_name}
                            </p>
                            <p className="text-gray-500">
                              {meeting.receiver?.user?.metadata?.delegate_details?.company}
                            </p>
                          </div>
                        </div>
                        <div className="flex items-center gap-4">
                          <button
                            className={`${statusBtnClass} text-white px-6 py-2 rounded-full font-medium`}
                            disabled={isAbsent || isBooked}
                          >
                            {statusLabel}
                          </button>
                          <button className="text-gray-400 hover:text-gray-600">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                            </svg>
                          </button>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </>
            )}

            {activeTab === 'scheduled' && (
              <div className="flex flex-col gap-4">
                {findAllMeetingsSponsor.map((meeting, index) => {
                  const isAbsent = !meeting?.receiver?.attendance?.includes(currentSlot?.day);

                  return (
                    <div key={index} className={` rounded-lg p-4 flex items-center justify-between shadow-sm ${isAbsent ? "bg-red-100 border-l-4 border-l-red-400" : "bg-green-100 border-l-4 border-l-green-400"}`}>
                      <div className="flex items-center gap-4">
                        <div className="w-12 h-12 rounded-full overflow-hidden border-2 border-gray-200">
                          <img
                            src={meeting.receiver?.user?.picture}
                            alt={meeting.receiver?.user?.first_name}
                            className="w-full h-full object-cover"
                          />
                          <span className="text-white text-lg font-bold">
                            {meeting.receiver?.user?.first_name?.charAt(0)}
                          </span>
                        </div>
                        <div>
                          <p className="font-semibold text-gray-700">
                            {meeting.receiver?.user?.first_name + " " + meeting.receiver?.user?.last_name}
                          </p>
                          <p className="text-gray-500">
                            {meeting.receiver?.user?.metadata?.delegate_details?.company}
                          </p>
                        </div>
                      </div>
                      <div className="flex items-center gap-4">
                        <button
                          className={`${meeting.btnClass} text-black w-full px-6 py-2 rounded-full font-semibold`}
                        >
                          {meeting.status.toUpperCase()}
                        </button>

                      </div>
                    </div>
                  );
                })}
              </div>
            )}

            {activeTab === 'pending' && (
              <div className="flex flex-col gap-4">
                {findAllMeetingsSponsorPending.map((meeting, index) => {
                  const isAbsent = !meeting?.receiver?.attendance?.includes(currentSlot?.day);

                  return (
                    <div key={index} className={` rounded-lg p-4 flex items-center justify-between shadow-sm ${isAbsent ? "bg-red-100 border-l-4 border-l-red-400" : "bg-green-100 border-l-4 border-l-green-400"}`}>
                      <div className="flex items-center gap-4">
                        <div className="w-12 h-12 rounded-full overflow-hidden border-2 border-gray-200">
                          <img
                            src={meeting.receiver?.user?.picture}
                            alt={meeting.receiver?.user?.first_name}
                            className="w-full h-full object-cover"
                          />
                          <span className="text-white text-lg font-bold">
                            {meeting.receiver?.user?.first_name?.charAt(0)}
                          </span>
                        </div>
                        <div>
                          <p className="font-semibold text-gray-700">
                            {meeting.receiver?.user?.first_name + " " + meeting.receiver?.user?.last_name}
                          </p>
                          <p className="text-gray-500">
                            {meeting.receiver?.user?.metadata?.delegate_details?.company}
                          </p>
                        </div>
                      </div>
                      <div className="flex items-center gap-4">
                        <button
                          className={`${meeting.btnClass} text-black w-full px-6 py-2 rounded-full font-semibold`}
                        >
                          {meeting.status.toUpperCase()}
                        </button>

                      </div>
                    </div>
                  );
                })}
              </div>
            )}

            {activeTab === 'rejected' && (
              <div className="flex flex-col gap-4">

                {findAllMeetingsSponsorRejected.map((meeting, index) => {
                  const isAbsent = !meeting?.receiver?.attendance?.includes(currentSlot?.day);

                  return (
                    <div key={index} className={` rounded-lg p-4 flex items-center justify-between shadow-sm ${isAbsent ? "bg-red-100 border-l-4 border-l-red-400" : "bg-green-100 border-l-4 border-l-green-400"}`}>
                      <div className="flex items-center gap-4">
                        <div className="w-12 h-12 rounded-full overflow-hidden border-2 border-gray-200">
                          <img
                            src={meeting.receiver?.user?.picture}
                            alt={meeting.receiver?.user?.first_name}
                            className="w-full h-full object-cover"
                          />
                          <span className="text-white text-lg font-bold">
                            {meeting.receiver?.user?.first_name?.charAt(0)}
                          </span>
                        </div>
                        <div>
                          <p className="font-semibold text-gray-700">
                            {meeting.receiver?.user?.first_name + " " + meeting.receiver?.user?.last_name}
                          </p>
                          <p className="text-gray-500">
                            {meeting.receiver?.user?.metadata?.delegate_details?.company}
                          </p>
                        </div>
                      </div>
                      <div className="flex items-center gap-4">
                        <button
                          className={`${meeting.btnClass} text-black w-full px-6 py-2 rounded-full font-semibold`}
                        >
                          {meeting.status.toUpperCase()}
                        </button>

                      </div>
                    </div>
                  );
                })}
              </div>
            )}

            {activeTab === 'completed' && (
              <div className="flex flex-col gap-4">
                {findAllMeetingsSponsorCompleted.map((meeting, index) => {
                  const isAbsent = !meeting?.receiver?.attendance?.includes(currentSlot?.day);

                  return (
                    <div
                      key={index}
                      className={` rounded-lg p-4 flex items-center justify-between shadow-sm ${
                        isAbsent
                          ? "bg-red-100 border-l-4 border-l-red-400"
                          : "bg-blue-100 border-l-4 border-l-blue-400"
                      }`}
                    >
                      <div className="flex items-center gap-4">
                        <div className="w-12 h-12 rounded-full overflow-hidden border-2 border-gray-200">
                          <img
                            src={meeting.receiver?.user?.picture}
                            alt={meeting.receiver?.user?.first_name}
                            className="w-full h-full object-cover"
                          />
                          <span className="text-white text-lg font-bold">
                            {meeting.receiver?.user?.first_name?.charAt(0)}
                          </span>
                        </div>
                        <div>
                          <p className="font-semibold text-gray-700">
                            {meeting.receiver?.user?.first_name +
                              " " +
                              meeting.receiver?.user?.last_name}
                          </p>
                          <p className="text-gray-500">
                            {meeting.receiver?.user?.metadata?.delegate_details?.company}
                          </p>
                        </div>
                      </div>
                      <div className="flex items-center gap-4">
                        <button className="bg-blue-500 hover:bg-blue-600 text-black w-full px-6 py-2 rounded-full font-semibold">
                          {meeting.status.toUpperCase()}
                        </button>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
          {selectedMeetingForDetails && (
            <div className="flex-none p-4 border-t flex flex-wrap gap-3 justify-end">
              <Button
                type="default"
                onClick={() => {
                  setNotesModalMeetingId(selectedMeetingForDetails._id);
                  setNotesModalOpen(true);
                  setNewNoteText("");
                }}
              >
                View / Add notes
              </Button>
              <Button
                type="primary"
                className="bg-blue-500 hover:bg-blue-600"
                disabled={
                  markingDone || selectedMeetingForDetails.status === "completed"
                }
                onClick={async () => {
                  if (!selectedMeetingForDetails?._id) return;
                  setMarkingDone(true);
                  try {
                    const body = {
                      ...selectedMeetingForDetails,
                      status: "completed",
                    };
                    const res = await updateMeeting({
                      id: selectedMeetingForDetails._id,
                      body,
                    });
                    if (res?.data?.status === 200) {
                      message.success("Meeting marked as completed.");
                      setIsModalOpen(false);
                      setSelectedMeetingForDetails(null);
                      refetch();
                    } else {
                      message.error(
                        res?.data?.message || "Failed to update meeting status."
                      );
                    }
                  } catch (err) {
                    console.error("Error marking meeting completed", err);
                    message.error("Failed to update meeting status.");
                  } finally {
                    setMarkingDone(false);
                  }
                }}
              >
                {markingDone
                  ? "Marking..."
                  : selectedMeetingForDetails.status === "completed"
                  ? "Completed"
                  : "Mark as completed"}
              </Button>
            </div>
          )}
        </div>
      </Modal>

      <Modal
        title="Meeting notes"
        open={notesModalOpen}
        onCancel={() => {
          setNotesModalOpen(false);
          setNotesModalMeetingId(null);
          setNewNoteText("");
        }}
        footer={null}
        destroyOnClose
        width={480}
      >
        {notesModalMeetingId && (() => {
          const notesMeeting = meetings?.find((m) => m._id === notesModalMeetingId);
          const notes = notesMeeting?.notes || [];
          return (
            <div className="space-y-4">
              <div className="max-h-[240px] overflow-y-auto space-y-3">
                {notes.length === 0 ? (
                  <p className="text-gray-500 text-sm">No notes yet.</p>
                ) : (
                  notes.map((note, idx) => (
                    <div key={idx} className="p-3 bg-gray-50 rounded-lg">
                      <p className="text-sm text-gray-800">{note.text}</p>
                      <p className="text-xs text-gray-500 mt-1">
                        {note.datetime ? new Date(note.datetime).toLocaleString() : ""}
                      </p>
                    </div>
                  ))
                )}
              </div>
              <div className="flex gap-2 pt-2 border-t">
                <Input.TextArea
                  placeholder="Add a note..."
                  value={newNoteText}
                  onChange={(e) => setNewNoteText(e.target.value)}
                  rows={2}
                  disabled={addingNote}
                />
                <Button
                  type="primary"
                  className="bg-primary"
                  onClick={async () => {
                    const text = newNoteText?.trim();
                    if (!text) return;
                    setAddingNote(true);
                    try {
                      await addMeetingNote({ id: notesModalMeetingId, text }).unwrap();
                      setNewNoteText("");
                      refetch();
                    } catch (err) {
                      console.log(err, "err");
                      message.error(err?.data?.error || "Failed to add note.");
                    } finally {
                      setAddingNote(false);
                    }
                  }}
                  disabled={!newNoteText?.trim() || addingNote}
                >
                  Add note
                </Button>
              </div>
            </div>
          );
        })()}
      </Modal>
    </>
  );
};

export default SponsorMeetings;
